var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.isMobile)?[_c('Moblie')]:[_c('Computer')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }